import { render } from "./separate.vue?vue&type=template&id=3ae5e08d"
import script from "./separate.vue?vue&type=script&lang=js"
export * from "./separate.vue?vue&type=script&lang=js"

import "./separate.vue?vue&type=style&index=0&id=3ae5e08d&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__